import { render, staticRenderFns } from "./datosBono.vue?vue&type=template&id=51e5b9b9&scoped=true&"
import script from "./datosBono.vue?vue&type=script&lang=js&"
export * from "./datosBono.vue?vue&type=script&lang=js&"
import style0 from "./datosBono.vue?vue&type=style&index=0&id=51e5b9b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5b9b9",
  null
  
)

export default component.exports